import { AudioFeatureType } from '../../api/cc-smarts/models/AudioFeature';

export const getAIFeatureName = (type: AudioFeatureType): string => {
	switch (type) {
		case AudioFeatureType.BRIEFING:
			return 'aiAudioBriefing';
		case AudioFeatureType.NARRATION:
			return 'aiAudioNarration';
	}
};
